const ButtonIcon = require('../elements/buttonicon.js')
const html = require('choo/html')
const MAX_TOP_VALUE = 90
const ROW_HEIGHT = 5
const PADDING = 2
const STICKERS_PER_ROW = 3
module.exports = function AppliedGlitches (args) {
  const {
    top,
    left,
    width,
    height,
    glitches = [],
    beginDrag,
    selectedGlitchApplicationId
  } = args
  const stickerRows = Math.ceil(glitches.length / STICKERS_PER_ROW)
  const leftVal = left + (width / 2)
  let topVal = top
  if (topVal > MAX_TOP_VALUE) {
    topVal -= (height + (stickerRows * ROW_HEIGHT) + PADDING)
  }
  const style = `top: ${topVal}%;left: ${leftVal}%;`
  const codeStickers = glitches.map(glitch => {
    const button = ButtonIcon({
      size: 'small',
      color: glitch.color,
      icon: glitch.icon,
      pickable: true,
      selected: glitch.applicationId === selectedGlitchApplicationId,
      onMouseDown: e => beginDrag(e, glitch)
    })
    return html`<div class="sticker">${button}</div>`
  })
  return html`
    <div class="code-stickers" style=${style}>
      ${codeStickers}
    </div>
  `
}